'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fas';
var iconName = 'tree-palm';
var width = 576;
var height = 512;
var aliases = [127796];
var unicode = 'f82b';
var svgPathData = 'M103 91.4l30.3 50.5c-4 3.5-8 7.2-12 11.2-71 71-60.2 151-32.7 191.3 5 7.3 15.2 7.3 21.4 1L248.6 206.9c4 10.8 7.8 26.2 9.7 47.2 4.2 46.5-1.6 116.8-32.7 216.4-3 9.7-1.3 20.3 4.8 28.5s15.6 13 25.8 13l64 0c16.1 0 29.8-12 31.8-28 12.4-99-2.3-207.2-31.7-292l126.6 0c2.8 0 5.4-1.5 6.9-3.9l19.6-32.7c3.1-5.2 10.6-5.2 13.7 0l19.6 32.7c1.4 2.4 4 3.9 6.9 3.9l46.7 0C569 192 576.2 184.8 574.6 176.1 565.5 128.2 516.5 64 416.2 64 372.5 64 338.6 76.2 313.4 93.8 296.7 49.4 248.2 0 160.2 0 59.8 0 10.8 64.2 1.7 112.1 .1 120.8 7.3 128 16.2 128l46.7 0c2.8 0 5.4-1.5 6.9-3.9L89.3 91.4c3.1-5.2 10.6-5.2 13.7 0z';

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faTreePalm = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;